import React, { useEffect, useState } from 'react';
import { Navigate, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from './AuthProvider';

export const ProtectedRoute = ({ allowedRoles }) => {
  const { user } = useAuth();
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    if (!user) {
      navigate("/logout");
    }
    setLoading(false);
  }, [navigate])

  return (
    <>
      {loading ? null : (user && user.groups.some(group => allowedRoles.includes(group.name))
        ? <Outlet /> // If user exists and has a correct role, render the child routes
        : user
          ? <Navigate to="/unauthorized" replace /> // Authenticated but wrong role
          : <Navigate to="/login" replace /> // Not authenticated
      )}
    </>
  );
};
